import { useRouteMatch } from 'react-router-dom'

import DashboardHeader from './components/DashboardHeader'
import DataSearch from './components/DataSearch'
import Jaqi from './components/Jaqi'
import { MetabaseAccountOverview } from './components/MetabaseAccountOverview'
import { MetabaseCampaignOverview } from './components/MetabaseCampaignOverview'
import { PAGES, PATH } from './interfaces'

export default function Dashboard() {
  const { path } = useRouteMatch()
  const selectedPage = PAGES.find((page) => page.path === path)

  return (
    <>
      <DashboardHeader />
      {selectedPage?.path === PATH.MetabaseAccount && (
        <MetabaseAccountOverview />
      )}
      {selectedPage?.path === PATH.MetabaseCampaign && (
        <MetabaseCampaignOverview />
      )}
      {selectedPage?.path === PATH.DataSearch && <DataSearch />}
      {selectedPage?.path === PATH.JaqiAi && <Jaqi />}
    </>
  )
}
